if (!customElements.get('jp-content-article')) {
  customElements.define('jp-content-article', class extends HTMLElement {
    connectedCallback() {
      this.initialize();
    }

    initialize() {
      if (this.initialized || !this.isConnected || this.dataset.jpArticleNavigationEnabled !== 'true') return;
      this.navigation = this.querySelector('[data-jp-article-navigation]');
      this.post = this.querySelector('[data-jp-article-post]');
      this.start = this.querySelector('[data-jp-article-start]');
      this.progress = this.querySelector('[data-jp-article-progress]');
      if (!this.navigation || !this.post || !this.start || !this.progress) {
        if (!this.initializationObserver) {
          this.initializationObserver = new MutationObserver(() => this.initialize());
          this.initializationObserver.observe(this, { childList: true, subtree: true });
        }
        return;
      }

      this.initializationObserver?.disconnect();
      this.initializationObserver = null;
      this.initialized = true;

      this.header = document.querySelector('.section-header');
      this.update = this.update.bind(this);
      this.schedule = this.schedule.bind(this);
      this.navigation.hidden = false;
      this.classList.add('jp-content-article--enhanced');
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.post);
        if (this.header) this.resizeObserver.observe(this.header);
      }
      this.schedule();
    }

    disconnectedCallback() {
      this.initializationObserver?.disconnect();
      this.initializationObserver = null;
      this.initialized = false;
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    schedule() {
      if (!this.frame) this.frame = requestAnimationFrame(this.update);
    }

    update() {
      this.frame = null;
      if (!this.isConnected) return;

      let headerOffset = 0;
      if (this.header) {
        const position = getComputedStyle(this.header).position;
        const rect = this.header.getBoundingClientRect();
        if (position === 'sticky' || position === 'fixed') {
          headerOffset = Math.max(0, Math.min(rect.bottom, window.innerHeight));
        }
      }

      const startRect = this.start.getBoundingClientRect();
      const postRect = this.post.getBoundingClientRect();
      const navigationHeight = this.navigation.getBoundingClientRect().height;
      const visible = startRect.top < 0 && postRect.bottom > headerOffset + navigationHeight;
      const available = Math.max(1, postRect.height - window.innerHeight + headerOffset + navigationHeight);
      const progress = Math.max(0, Math.min(1, (headerOffset + navigationHeight - postRect.top) / available));

      this.style.setProperty('--jp-content-article-nav-offset', `${headerOffset}px`);
      this.progress.style.setProperty('--jp-content-article-progress', progress.toFixed(4));
      this.progress.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      this.navigation.classList.toggle('jp-content-article__navigation--visible', visible);
      this.navigation.setAttribute('aria-hidden', String(!visible));
      this.navigation.inert = !visible;
    }
  });
}
